import React, {   useRef, useEffect, useState, useCallback  } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables"; 
import { useNavigate } from 'react-router-dom'; 
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DropzoneAreaBase } from 'material-ui-dropzone';   
import { es } from 'date-fns/locale'; 
import Box from '@mui/material/Box';      
import MenuItem  from "@mui/material/MenuItem";
import TextField from '@mui/material/TextField';  
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import image1 from "components/photos/sidebars/takephoto.jpeg";
import TableSortingProductLiquid from "pages/sheet/editOrCreateSheet/SortingTablesProductLiquid";
import TableSortingProduct from "pages/sheet/editOrCreateSheet/SortingTablesProduct";

const initialStateSheet = {
  "id" : "",
  "ownsheet_id" : "", 
  "defaultStore_id":0,
  "tradenam":"",
  "useraccount_id":0,
  "username":"",
  "num_sheet":"",
  "date_sheet":"",
  "vehicle_marca":"",
  "vehicle_model":"",
  "vehicle_sheet":"",
  "frame_sheet":"",
  "sheetStatus_id":  1,
  "sheetStatus_namees": "",
  "sheetStatus_nameen": "",
  "isFinished": false,
  "productLinesheet":[],
  "productliquidLinesheet":[],
  "imagesheet":[]
};
 
const initialSheetSateToSelect = [{
  "id": "",
  "namees": "",
  "nameen": ""
}];
 
const initialMarcaToSelect = [{
  "id": "",
  "marca": ""
}];

const initialModelToSelect = [{
  "id": "",
  "model": ""
}];

export const SheetEditOrCreate = ({id, showModalSheetSettings,setShowModalSheetSettings,typeOfList}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [formSheet, setFormSheet] = useState(initialStateSheet); 
  const [errorsFormSheet, setErrorsFormSheet] = useState({});
  const [foundNumberOfShhet, setFoundNumberOfShhet ]= useState(false);
  const [sheetStateToSelect,setSheetStateToSelect]= useState(initialSheetSateToSelect); 
  const [previewImage, setPreviewImage] = useState(null);
  const [files, setFiles] = useState([]);
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [productLinesheet, setProductLinesheet] = useState([]);
  const [productLiquidLinesheet, setProductLiquidLinesheet] = useState([]);
  const [marcaToSelect,setMarcaToSelect]= useState(initialMarcaToSelect);  
  const [filteredMarca, setFilteredMarca] = useState([]); // Opciones filtradas
  const [highlightedIndexMarca, setHighlightedIndexMarca] = useState(-1); // Índice de la opción resaltada 
  
  const [modelToSelect,setModelToSelect]= useState(initialModelToSelect);  
  const [filteredModel, setFilteredModel] = useState([]); // Opciones filtradas
  const [highlightedIndexModel, setHighlightedIndexModel] = useState(-1); // Índice de la opción resaltada 
  
  const videoRef = useRef(null);
  const canvasRef = useRef(null); 
  const dispatch = useDispatch();
  const navigate = useNavigate();  
    
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape') {
         if (showCameraModal) {
          const video = videoRef.current;
          if (video && video.srcObject) {
            video.srcObject.getTracks().forEach(track => track.stop());
          }
          setShowCameraModal(false);
          return; // no cierres todo el Drawer
        }
        if (showModalSheetSettings) {
          setFormSheet(initialStateSheet);
          setFormSheet(formSheet => ({
            ...formSheet,
            productLinesheet:[],
            productliquidLinesheet:[],
            imagesheet:[]
          }));  
          setErrorsFormSheet({});
          setFoundNumberOfShhet(false);
          setSheetStateToSelect(initialSheetSateToSelect);
          setPreviewImage(null);
          setFiles([]);
          setShowModalSheetSettings(false);
          dispatch(setLoading(false)); 
          setProductLinesheet([]);
          setProductLiquidLinesheet([]); 
          setMarcaToSelect(initialMarcaToSelect);
          setFilteredMarca([]);
          setHighlightedIndexMarca(-1); 
          setModelToSelect(initialModelToSelect);
          setFilteredModel([]);
          setHighlightedIndexModel(-1); 
          if (formSheet.id!==undefined && formSheet.id!==null && formSheet.id!=="" && formSheet.id!=="0" && formSheet.id!==0){
            navigate(typeOfList==="1"?"/sheet":"/sheetended") ;
          }else{
            navigate("/home"); 
          } 
          return () => {};
        }
      }  
    },
    [
      setFormSheet,  
      setErrorsFormSheet,
      setFoundNumberOfShhet,
      setSheetStateToSelect,
      setPreviewImage,
      setFiles,
      showCameraModal,
      showModalSheetSettings,
      setShowModalSheetSettings,
      setProductLinesheet,
      setProductLiquidLinesheet,
      navigate,  
      typeOfList,
      formSheet.id,
      setMarcaToSelect,
      setFilteredMarca,
      setHighlightedIndexMarca,
      setModelToSelect,
      setFilteredModel,
      setHighlightedIndexModel,
      dispatch]
  );
  
  const handleCloseDataEditSheet = () => {
    if (showCameraModal) {
      // 👈 Si está abierta la cámara, paramos el stream y cerramos solo el modal
      const video = videoRef.current;
      if (video && video.srcObject) {
        video.srcObject.getTracks().forEach(track => track.stop());
      }
      setShowCameraModal(false);
      return; // no cierres todo el Drawer
    }
    setFormSheet(initialStateSheet);
    setFormSheet(formSheet => ({
      ...formSheet,
      productLinesheet:[],
      productliquidLinesheet:[],
      imagesheet:[]
    }));  
    setErrorsFormSheet({});
    setFoundNumberOfShhet(false);
    setSheetStateToSelect(initialSheetSateToSelect);
    setPreviewImage(null);
    setFiles([]);
    setShowModalSheetSettings(false);
    dispatch(setLoading(false)); 
    setProductLinesheet([]);
    setProductLiquidLinesheet([]);
    setMarcaToSelect(initialMarcaToSelect);
    setFilteredMarca([]);
    setHighlightedIndexMarca(-1); 
    setModelToSelect(initialModelToSelect);
    setFilteredModel([]);
    setHighlightedIndexModel(-1); 
    if (formSheet.id!==undefined && formSheet.id!==null && formSheet.id!=="" && formSheet.id!=="0" && formSheet.id!==0){
      navigate(typeOfList==="1"?"/sheet":"/sheetended") ;
    }else{
      navigate("/home"); 
    } 
    return () => {};
	};

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
  };
    
  // Dentro del componente
  const debouncedHandleSearchMarca = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredMarca([]);
      setHighlightedIndexMarca(-1);
      return;
    }
    const filtered = marcaToSelect
      .filter(vehicle => vehicle && vehicle.marca)
      .filter(vehicle => {
        const vehiclestoremarca= vehicle.marca.toUpperCase();
        return vehiclestoremarca.includes(upperValue);
      })
      .slice(0, 40); // limitar resultados
      setFilteredMarca(filtered);
      setHighlightedIndexMarca(0);
  }, 300);
  const handleSelectMarca = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFormSheet(formSheet => ({
      ...formSheet,
      vehicle_marca: (vehicle.marca || "") 
    }));
    setFilteredMarca([]);
    setHighlightedIndexMarca(-1);
  }; 
  const handleKeyDownMarca = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredMarca.length === 0 && formSheet.vehicle_marca.trim() === "") {
        setFilteredMarca(marcaToSelect);
        setHighlightedIndexMarca(0);
      } else {
        setHighlightedIndexMarca((prevIndex) => {
          const nextIndex = prevIndex < filteredMarca.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexMarca((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexMarca >= 0) {
      if (highlightedIndexMarca >= 0 && highlightedIndexMarca < filteredMarca.length) {
        handleSelectMarca(filteredMarca[highlightedIndexMarca]);
      }
    } else if (event.key === "Escape") {
      const isValid = marcaToSelect.some((vehicle) => {
        if (!vehicle || !vehicle.marca) return false; 
        const normalizedVehicleMarca = vehicle.marca.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicleMarca = formSheet.vehicle_marca.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicleMarca === normalizedInputVehicleMarca;
      }); 
      if (!isValid) {
        setFormSheet((formSheet) => ({
          ...formSheet,
          vehicle_marca: "",
        }));
      } 
      setFilteredMarca([]);
      setHighlightedIndexMarca(-1);
    }
  }; 

  // Dentro del componente
  const debouncedHandleSearchModel = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredModel([]);
      setHighlightedIndexModel(-1);
      return;
    }
    const filtered = modelToSelect
      .filter(vehicle => vehicle && vehicle.model)
      .filter(vehicle => {
        const vehiclestoremodel = vehicle.model.toUpperCase();
        return vehiclestoremodel.includes(upperValue);
      })
      .slice(0, 40); // limitar resultados
      setFilteredModel(filtered);
      setHighlightedIndexModel(0);
  }, 300);
  const handleSelectModel = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFormSheet(formSheet => ({
      ...formSheet,
      vehicle_model: (vehicle.model || "") 
    }));
    setFilteredModel([]);
    setHighlightedIndexModel(-1);
  }; 
  const handleKeyDownModel = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredModel.length === 0 && formSheet.vehicle_model.trim() === "") {
        setFilteredModel(modelToSelect);
        setHighlightedIndexModel(0);
      } else {
        setHighlightedIndexModel((prevIndex) => {
          const nextIndex = prevIndex < filteredModel.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexModel((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexModel >= 0) {
      if (highlightedIndexModel >= 0 && highlightedIndexModel < filteredModel.length) {
        handleSelectModel(filteredModel[highlightedIndexModel]);
      }
    } else if (event.key === "Escape") {
      const isValid = modelToSelect.some((vehicle) => {
        if (!vehicle || !vehicle.model) return false; 
        const normalizedVehicleModel = vehicle.model.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicleModel = formSheet.vehicle_model.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicleModel === normalizedInputVehicleModel;
      }); 
      if (!isValid) {
        setFormSheet((formSheet) => ({
          ...formSheet,
          vehicle_model: "",
        }));
      } 
      setFilteredModel([]);
      setHighlightedIndexModel(-1);
    }
  };

  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };

  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setHighlightedIndexMarca(-1); 
      setFilteredMarca([]); 
      setHighlightedIndexModel(-1); 
      setFilteredModel([]); 
    }
  }, []); 

  const handleAddImage = (newFiles) => {
    newFiles = newFiles.filter((file) => !files.find((f) => f.data === file.data));
    setFiles([...files, ...newFiles]);
  };

  const handleDeleteImage = (deleted) => {
    setFiles(files.filter((f) => f !== deleted));
  };
 
 const handleBlurDataEditSheet = (e) => {
    handleChangeDataEditSheet(e);
    setErrorsFormSheet(validateformSheet());
  };
    
  const handleChangeDataEditSheet = (e) => {
    const { name, value } = e.target;
    setFormSheet(formSheet => ({
      ...formSheet,
      [name]: value,
    }));
  };

  const handleBlurSelectDate = (e) => {
    handleChangeSelectDate(e);
    setErrorsFormSheet(validateformSheet());
  };

  const handleChangeSelectDate = (event) => {
    const selectedDate = event ? new Date(event) : null;
    setFormSheet(formSheet => ({
      ...formSheet,
      date_sheet: selectedDate 
    }));
  };
 
  const validateformSheet = () => {
    let errorsFormSheet = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
       

    if (!formSheet.date_sheet || formSheet.date_sheet===null || formSheet.date_sheet===""){
      errorsFormSheet.date_sheet = 'Text_FieldDateSheet_Required';
    }
    
    if (!formSheet.num_sheet || formSheet.num_sheet===null || formSheet.num_sheet===""){
      errorsFormSheet.num_sheet = 'Text_Field_NumSheet_Required';
    }else{
      if (foundNumberOfShhet){
        errorsFormSheet.num_sheet='Text_FieldnumberSheetExist';
      }else{
        if (regexInvalidCharacters.test(formSheet.num_sheet)) {
          errorsFormSheet.num_sheet = 'Text_TextNoValid';
        }
      }
    } 
    if (!formSheet.vehicle_sheet || formSheet.vehicle_sheet===null || formSheet.vehicle_sheet===""){
      errorsFormSheet.vehicle_sheet = 'Text_Field_LicensePlateSheet_Required';
    }else{
      if (regexInvalidCharacters.test(formSheet.vehicle_sheet)) {
        errorsFormSheet.vehicle_sheet = 'Text_TextNoValid';
      } 
    }
     if (regexInvalidCharacters.test(formSheet.vehicle_marca)) {
      errorsFormSheet.vehicle_marca = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formSheet.vehicle_model)) {
      errorsFormSheet.vehicle_model = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formSheet.frame_sheet)) {
      errorsFormSheet.frame_sheet = 'Text_TextNoValid';
    } 
    return errorsFormSheet;
  };

  const handleConfirmFetchSheet = (dataToSend) => {   
    const fetchData = async () => { 
      try {
        const getData = id !== "0"
          ? await helpHttp().put(ENDPOINT, `sheet/updatesheet`, token, dataToSend)
          : await helpHttp().post(ENDPOINT, `sheet/savesheet`, token, dataToSend);
        if (getData.status === "OK") {
          dispatch(successErrorAction(t('Text_SaveData')));
         
        } else {
          dispatch(warningErrorAction(t(getData.cause)));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    fetchData(); 
    handleCloseDataEditSheet();
    return () => {};
  };

  const splitFileBase64=(fileToConvert)=>{    
    var arrayAuxiliar=[];
    arrayAuxiliar=fileToConvert.split(',')
    return arrayAuxiliar[1];
  } 
  
  const handleSubmitDataEditSheet = () => {
    const errors = validateformSheet();
    setErrorsFormSheet(errors);
     if (Object.keys(errors).length === 0 && formSheet.date_sheet && formSheet.vehicle_sheet && formSheet.date_sheet && !foundNumberOfShhet) {
      // files()
       const imagesheet = files.map((file, index) => ({
        id: null, // es nuevo, por lo que no tiene ID
        sheet_id: formSheet.id || null, // si ya existe el sheet
        pathdocument: null, // el backend lo genera
        relativepathdocument: null, // el backend lo genera
        filename: file.file?.name || `image_${index + 1}.jpg`,
        createdate: new Date(),
        datafile:splitFileBase64(file.data), // base64 del archivo
        type: file.file?.type || "image/jpeg",
        sourcepath: null // el backend lo genera
      }));
      const formToSend = {
        id : formSheet.id,
        ownsheet_id : formSheet.ownsheet_id, 
        defaultStore_id: defaultStore.id,
        useraccount_id: useraccount_id,
        num_sheet: formSheet.num_sheet,
        date_sheet: formSheet.date_sheet,
        vehicle_marca: formSheet.vehicle_marca,
        vehicle_model: formSheet.vehicle_model,
        vehicle_sheet:formSheet.vehicle_sheet,
        frame_sheet: formSheet.frame_sheet,
        sheetStatus_id:  formSheet.sheetStatus_id,
        sheetStatus_namees: formSheet.sheetStatus_namees,
        sheetStatus_nameen: formSheet.sheetStatus_nameen,
        isFinished: formSheet.isFinished,
        productLinesheet:productLinesheet,
        productliquidLinesheet:productLiquidLinesheet,
        imagesheet:imagesheet
      };
      handleConfirmFetchSheet(formToSend); 
    } else {
      if (errors.date_sheet) {
          dispatch(warningErrorAction(t(errors.date_sheet)));
        } else if (errors.num_sheet) {
          dispatch(warningErrorAction(t(errors.num_sheet)));
        } else if (errors.vehicle_sheet) {
          dispatch(warningErrorAction(t(errors.vehicle_sheet)));
        } else if (errors.vehicle_marca) {
          dispatch(warningErrorAction(t(errors.vehicle_marca)));
        } else if (errors.vehicle_model) {
          dispatch(warningErrorAction(t(errors.vehicle_model)));
        } else if (errors.frame_sheet) {
          dispatch(warningErrorAction(t(errors.frame_sheet)));
        } else {
          dispatch(warningErrorAction(t('Text_IncorrectData')));
        }
    }
  }; 
   
  useEffect(() => {
    let isMounted = true;
    const fetchExistNumberSheet = async () => {
        try {
          const getData = await helpHttp().get5(ENDPOINT,`sheet/getexistnumbersheet`,token,defaultStore.id,formSheet.num_sheet.replace(/[.\-/\\|]/g, "")) ;
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setFoundNumberOfShhet(getData!==formSheet.id && getData>0)       
          }
        } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    }; 
    if (formSheet.num_sheet!==undefined && formSheet.num_sheet!==null && formSheet.num_sheet!=="" && formSheet.num_sheet && formSheet.num_sheet.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberSheet();
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,formSheet.num_sheet,formSheet.id,defaultStore.id]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (showCameraModal && videoRef.current) {
      navigator.mediaDevices.getUserMedia({ video: true })
        .then(stream => {
          videoRef.current.srcObject = stream;
        })
        .catch(err => {
          dispatch(warningErrorAction(t('Text_CameraNotAccessible')));
          setShowCameraModal(false);
        });
    }
  }, [showCameraModal, dispatch, t]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataMarcaVehiclesType= async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`sheet/getmarcavehicletypeslist/`,token,
          "-1"); 
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
              setMarcaToSelect(getData);
          }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData')));  
      }
    };  
    if (showModalSheetSettings){
      fetchDataMarcaVehiclesType();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,formSheet.vehicle_marca,showModalSheetSettings]);
  
  useEffect(() => {
    let isMounted = true;
      const fetchDataModelVehiclesType = async () => {
      try {
        const getData = await helpHttp().get5(ENDPOINT,`sheet/getmodelvehicletypesList`, token,
          (formSheet.vehicle_marca && formSheet.vehicle_marca.replace(/[.\-/\\|]/g, "").trim()!=="")?formSheet.vehicle_marca.replace(/[.\-/\\|]/g, "").trim():"-1",
          (formSheet.vehicle_model && formSheet.vehicle_model.replace(/[.\-/\\|]/g, "").trim()!=="")?formSheet.vehicle_model.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setModelToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showModalSheetSettings && formSheet.vehicle_marca && formSheet.vehicle_marca.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchDataModelVehiclesType();  
    }else{
      setModelToSelect(initialModelToSelect);
    }
    return () => { isMounted = false }; 
  }, [t,token,dispatch,i18n,formSheet.id,formSheet.vehicle_marca,formSheet.vehicle_model,showModalSheetSettings]);

 
  useEffect(() => {
    let isMounted = true;
     const fetchDataSheetStatus = async () => {
      try {
        const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `sheetstatus/simplesheetstatusbynamees`, token)
          : await helpHttp().get(ENDPOINT, `sheetstatus/simplesheetstatusbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setSheetStateToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchDataSheet = async () => { 
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`sheet/getsheetbyid/`,token,id);
        if (getData.err) {
          setFormSheet(initialStateSheet); 
          dispatch(setLoading(false)); 
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setFormSheet(getData);
          setProductLinesheet(getData.productLinesheet);
          setProductLiquidLinesheet(getData.productliquidLinesheet);
          if (getData.imagesheet.length>0){
            const existArrayFileToUpload=[];
            getData.imagesheet.map((existFileToUpload)=>{
              const imageDataUrl = "data:"+existFileToUpload.type+";base64,"+existFileToUpload.datafile
              let result = new File([imageDataUrl.arrayBuffer], existFileToUpload.filename, { type: existFileToUpload.type, lastModified:existFileToUpload.createdate })
              return(
                (existFileToUpload.datafile!==undefined && existFileToUpload.datafile!==null && existFileToUpload.datafile!=="" )&& existArrayFileToUpload.push(
                  {
                    "data":imageDataUrl,
                    "file":result
                  }
                ))
            })
            setFiles(existArrayFileToUpload);
          }else{
            setFiles([]);
          }
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
    const fetchGetNumberSheet = async () => {
      try {
        const getData = await helpHttp().get11(ENDPOINT,`sheet/getlastnumbersheet`,token,defaultStore.id) ;
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted && getData>0) {
          setFormSheet(formSheet => ({
            ...formSheet,
            num_sheet: getData.toString()
          }));       
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    
    const fetchGetProductLiquid = async () => {
      try {
        const getData = await helpHttp().get12(ENDPOINT,`linessheet/getemptylinesproductliquid`,token) ;
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setProductLiquidLinesheet(getData); 
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 

     const fetchGetProduct = async () => {
      try {
        const getData = await helpHttp().get12(ENDPOINT,`linessheet/getemptylinesproduct`,token) ;
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setProductLinesheet(getData); 
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 

    if (showModalSheetSettings ){
      if (id!=="0"){
        if (formSheet.id===""){
          dispatch(setLoading(true));
          fetchDataSheetStatus();
          fetchDataSheet();
        }
      }else{
        fetchDataSheetStatus(); 
        setFormSheet(initialStateSheet);
        setFormSheet(formSheet => ({
          ...formSheet, 
          id:0,
          ownsheet_id:id,
          defaultStore_id:defaultStore.id,
          useraccount_id:useraccount_id,
          num_sheet:"",
          date_sheet:new Date(),
          vehicle_marca:"",
          vehicle_model:"",
          vehicle_sheet:"",
          frame_sheet:"",
          sheetStatus_id:  1,
          sheetStatus_namees: "",
          sheetStatus_nameen: "",
          isFinished: false,
          productLinesheet:[],
          productliquidLinesheet:[],
          imagesheet:[]
        }));
        setFormSheet(formSheet => ({
          ...formSheet,
          productLinesheet:[],
          productliquidLinesheet:[],
          imagesheet:[]
        }));
        fetchGetNumberSheet();
        fetchGetProduct();
        fetchGetProductLiquid(); 
      } 
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,i18n.language,formSheet.id,defaultStore.id,useraccount_id,isLoadingData,showModalSheetSettings]);  

  return (
      <>
        {showModalSheetSettings ? ( 
          <div className="container-fluid formgeneral-send-wrapper">
            {/* Search input */}
            <Box sx={{ bgcolor: '#ffffff', width: '1050px'}}>
              <div className="formgeneral-card-header">
                {/* HEADER */}
                <div className="formgeneral-card-header">
                  <div className="formgeneral-header-content">
                    <div className="formgeneral-header-title2">
                      {id === "0" ? t('Text_TITLE_CREATE_SHEET') : t('Text_TITLE_EDIT_SHEET')}
                    </div>
                    <div className="email-card-actions">
                      <button type="button" className="email-send-btn" onClick={handleSubmitDataEditSheet} >
                        {id === "0" ? t('Button_Create') : t('Button_Update')}
                      </button> 
                      <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={handleCloseDataEditSheet} >
                         {t('Button_Cancel')}
                      </button>  
                    </div>
                  </div>
                </div>
                <br/>
                <div className="formgeneral-card-form">
                  <div className="upload-box" style={{ width: '100%' }}>
                    <img src={image1} alt="Camera Icon" style={{ width: 50, height: 50 }} />
                    <button type="button" className="btn-blue-outline" onClick={() => setShowCameraModal(true)} >
                      {t('Button_TakePhoto')}
                    </button>
                    <DropzoneAreaBase
                      initialFiles={files}
                      fileObjects={files}
                      acceptedFiles={['image/*']}
                      maxFileSize={20000000}
                      filesLimit={12}
                      onAdd={handleAddImage}
                      onDelete={handleDeleteImage}
                      showAlerts={false}
                      dropzoneText={t('Text_DragDropPhotos')}
                      showPreviews={false}
                      showPreviewsInDropzone={false}
                      showFileNamesInPreview={false}
                      showFileNames={false}
                      useChipsForPreview
                      previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                      previewChipProps={{ classes: { root: 'upload-preview-chip' } }}
                      classes={{
                        root: 'upload-dropzone-root',
                        icon: 'upload-dropzone-icon',
                        text: 'upload-dropzone-text',
                      }}
                    />
                  </div>
                  {files.length > 0 && (
                    <div className="preview-thumbnails-wrapper">
                      <div className="preview-thumbnails">
                        {files.map((fileObj, index) => (
                          <div key={index} className="thumbnail-container">
                            <img
                              src={fileObj.data}
                              alt={`preview-${index}`}
                              className="thumbnail-image"
                            /> 
                            <button
                              type="button"
                              onClick={() => handleDeleteImage(fileObj)}
                              className="thumbnail-delete-btn"
                              title={t('Text_Delete')}
                            >
                              &times;
                            </button> 
                            <button
                              type="button"
                              onClick={() => setPreviewImage(fileObj.data)}
                              className="thumbnail-zoom-btn"
                              title={t('Text_Zoom')}
                            >
                              🔍
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )} 
                  
                  {!isLoadingData ?
                    <>
                      <form className="createform" onSubmit={handleCloseDataEditSheet}>  
                        <div className="form-group"> 
                          <br/>
                          <div className="formgeneral-header-title2">
                            {t('Text_SHEET_Title')}
                          </div> 
                          <hr className="sidebar-divider d-none d-md-block"/>
                          <div className="row p-2">
                            <div className="row">
                              {/* Fecha de Entrada */}
                              <div className="col-md-6 mb-1">
                                <label className="text-primary" style={{ fontSize: 18 }}>
                                  {t('Text_SHEET_DATE')} :
                                </label>
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                  <DesktopDatePicker
                                    id="date_sheet"
                                    name="date_sheet"
                                    value={formSheet.date_sheet !== null ? new Date(formSheet.date_sheet) : null}
                                    format={i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy"}
                                    onBlur={handleBlurSelectDate}
                                    onChange={handleChangeSelectDate}
                                    slotProps={{
                                      textField: {
                                        placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                        sx: { width: '100%', fontSize: '18px' },
                                        InputProps: { style: { fontSize: '18px' } },
                                        InputLabelProps: { style: { fontSize: '18px', background: '#FFFFFF' } },
                                      }
                                    }}
                                  />
                                </LocalizationProvider>
                              </div>

                              {/* Número de orden */}
                              <div className="col-md-6 mb-1">
                                <label className="text-primary" style={{ fontSize: 18 }}>
                                  {t('Text_SHEET_NUM').toUpperCase()} :
                                </label>
                                <TextField
                                  id="num_sheet"
                                  name="num_sheet"
                                  value={formSheet.num_sheet}
                                  inputProps={{ style: { fontSize: '18px' }, maxLength: 50 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                  label={errorsFormSheet.num_sheet != null ? t(errorsFormSheet.num_sheet) : t('PlaceHolder_SHEET_NUM')}
                                  placeholder={t('PlaceHolder_SHEET_NUM')}
                                  variant="outlined"
                                  fullWidth
                                  onBlur={handleBlurDataEditSheet}
                                  onChange={handleChangeDataEditSheet}
                                />
                              </div>

                              {/* Marca */}
                              <div className="col-md-6 mb-1">
                                <label className="text-primary" style={{ fontSize: 18 }}>
                                  {t('Text_SHEET_MARCA')} :
                                </label>
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="vehicle_marca"
                                    name="vehicle_marca"
                                    value={formSheet.vehicle_marca}
                                    onChange={(e) => {
                                      setFormSheet(prev => ({
                                        ...prev,
                                        vehicle_marca: e.target.value.toUpperCase() 
                                      }));
                                      debouncedHandleSearchMarca(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownMarca}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsFormSheet.vehicle_marca != null
                                      ? t(errorsFormSheet.vehicle_marca)
                                      : t('Text_SHEET_MARCA')}
                                    placeholder={t('PlaceHolder_SHEET_MARCA')}
                                    inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                    variant="outlined"
                                    fullWidth
                                  />
                                  {filteredMarca.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: '0px',
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: '18px',
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {filteredMarca.map((vehicletype, index) => (
                                        <MenuItem
                                          key={vehicletype.id}
                                          onClick={() => handleSelectMarca(vehicletype)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor: index === highlightedIndexMarca ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexMarca ? "white" : "black",
                                          }}
                                        >
                                          {vehicletype.marca}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )} 
                                  </span> 
                                
                              {/* Modelo */}
                              </div>
                              <div className="col-md-6 mb-1">
                                <label className="text-primary" style={{ fontSize: 18 }}>
                                  {t('Text_SHEET_MODEL')} :
                                </label>
                                  <span style={{ position: "relative" }} >
                                    <TextField
                                    id="vehicle_model"
                                    name="vehicle_model"
                                    value={formSheet.vehicle_model}
                                    onChange={(e) => {
                                      setFormSheet(prev => ({
                                        ...prev,
                                        vehicle_model: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchModel(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownModel}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsFormSheet.vehicle_model!=null && errorsFormSheet.vehicle_model!==""?t(errorsFormSheet.vehicle_model):t('Text_SHEET_MODEL')}
                                    placeholder={t('PlaceHolder_SHEET_MODEL')}
                                    inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    variant="outlined"
                                    fullWidth
                                  /> 
                                  {/* Desplegable dinámico */}
                                  {filteredModel.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: '0px',
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: '18px',
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                    {filteredModel.map((vehicle, index) => (
                                      <MenuItem
                                        key={vehicle.id}
                                        onClick={() => handleSelectModel(vehicle)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexModel ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexModel ? "white" : "black",
                                        }}
                                      >
                                        {vehicle.model}
                                      </MenuItem>
                                    ))}
                                  </div>
                                  )}
                                </span>  
                              </div>

                              {/* Matrícula */}
                              <div className="col-md-6 mb-1">
                                <label className="text-primary" style={{ fontSize: 18 }}>
                                  {t('Text_SHEET_LICENSEPLATE')} :
                                </label>
                                <TextField
                                  id="vehicle_sheet"
                                  name="vehicle_sheet"
                                  value={formSheet.vehicle_sheet}
                                  inputProps={{ style: { fontSize: '18px' }, maxLength: 50 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                  label={errorsFormSheet.vehicle_sheet != null ? t(errorsFormSheet.vehicle_sheet) : t('PlaceHolder_SHEET_LICENSEPLATE')}
                                  placeholder={t('PlaceHolder_SHEET_LICENSEPLATE')}
                                  variant="outlined"
                                  fullWidth
                                  onBlur={handleBlurDataEditSheet}
                                  onChange={handleChangeDataEditSheet}
                                />
                              </div>

                              {/* Bastidor */}
                              <div className="col-md-6 mb-1">
                                <label className="text-primary" style={{ fontSize: 18 }}>
                                  {t('Text_SHEET_FRAME')} :
                                </label>
                                <TextField
                                  id="frame_sheet"
                                  name="frame_sheet"
                                  value={formSheet.frame_sheet}
                                  inputProps={{ style: { fontSize: '18px' }, maxLength: 50 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                  label={errorsFormSheet.frame_sheet != null ? t(errorsFormSheet.frame_sheet) : t('PlaceHolder_SHEET_FRAME')}
                                  placeholder={t('PlaceHolder_SHEET_FRAME')}
                                  variant="outlined"
                                  fullWidth
                                  onBlur={handleBlurDataEditSheet}
                                  onChange={handleChangeDataEditSheet} 
                                />
                              </div>

                                {/* ESTADO */}
                              <div className="col-md-6 mb-1">
                                <label className="text-primary" style={{ fontSize: 18 }}>
                                  {t('Text_SHEET_STATUS')} :
                                </label>
                                <TextField
                                  id="sheetStatus_id"
                                  name="sheetStatus_id"
                                  value={ (formSheet.sheetStatus_id === undefined || formSheet.sheetStatus_id ===null || formSheet.sheetStatus_id ===""
                                      || formSheet.sheetStatus_id ==="0" || formSheet.sheetStatus_id ===1)?1:formSheet.sheetStatus_id}
                                  inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                  variant="outlined"
                                  fullWidth
                                  onBlur={handleBlurDataEditSheet}
                                  onChange={handleChangeDataEditSheet}
                                  helperText={errorsFormSheet.sheetStatus_id!=null  && errorsFormSheet.sheetStatus_id!==""?t(errorsFormSheet.sheetStatus_id):""}
                                  select
                                  SelectProps={{
                                      native: true,
                                      value: (formSheet.sheetStatus_id === undefined || formSheet.sheetStatus_id ===null || formSheet.sheetStatus_id ===""
                                          || formSheet.sheetStatus_id ==="0" || formSheet.sheetStatus_id ===0)?1: formSheet.sheetStatus_id
                                  }}>
                                  {sheetStateToSelect.map((option) => (
                                      <option key={option.id} value={option.id}>
                                          {i18n.language==="es"?option.namees:option.nameen}
                                      </option>
                                  ))}
                                </TextField> 
                              </div>
                            </div>
                          </div>
                        </div>
                        <br/>
                        <div style={{ width: '100%', padding: '0 rem' }}>
                          <div className="formgeneral-header-title2">
                            {t('Text_SHEET_Title1')}
                          </div> 
                          <hr className="sidebar-divider d-none d-md-block"/>
                          <TableSortingProductLiquid
                            productLiquidLinesheet={productLiquidLinesheet}
                            setProductLiquidLinesheet={setProductLiquidLinesheet}
                          />
                        </div>
                        <br/>
                        <div style={{ width: '100%', padding: '0 rem' }}>
                          <div className="formgeneral-header-title2">
                            {t('Text_SHEET_Title2')}
                          </div> 
                          <hr className="sidebar-divider d-none d-md-block"/>
                          <TableSortingProduct
                            productLinesheet={productLinesheet}
                            setProductLinesheet={setProductLinesheet}
                          />
                        </div>
                      </form>  
                    </>
                  :
                    <LoadingNews/>
                  }
                </div>
              </div>
            </Box>
          <br/> 
          {previewImage && (
          <div className="preview-modal-overlay">
            <div className="preview-modal-content">
              <button
                type="button"
                onClick={() => setPreviewImage(null)}
                className="preview-close-button"
                title={t('Text_Close')}
              >
                &times;
              </button>

              <img
                src={previewImage}
                alt={t('Text_View_Great')}
                className="preview-image"
              />
            </div>
          </div>
        )} 
        {showCameraModal && (
          <div className="camera-modal-overlay">
            <div className="camera-modal-content">
              <video
                ref={videoRef}
                autoPlay
                playsInline
                width="320"
                height="240"
                className="camera-video"
              />
              <canvas ref={canvasRef} style={{ display: 'none' }} />
              <div className="camera-buttons">
                <button
                  className="btn btn-success"
                  onClick={() => {
                    const video = videoRef.current;
                    const canvas = canvasRef.current;
                    const context = canvas.getContext('2d');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    context.drawImage(video, 0, 0, canvas.width, canvas.height);
                    const dataUrl = canvas.toDataURL('image/jpeg');
                    handleAddImage([{ data: dataUrl }]);
                    setShowCameraModal(false);
                    if (video.srcObject) {
                      video.srcObject.getTracks().forEach(track => track.stop());
                    }
                  }}
                >
                  📸 {t('Button_Capture')}
                </button>

                <button
                  className="btn btn-danger"
                  onClick={() => {
                    const video = videoRef.current;
                    if (video.srcObject) {
                      video.srcObject.getTracks().forEach(track => track.stop());
                    }
                    setShowCameraModal(false);
                  }}
                >
                  ❌ {t('Button_Cancel')}
                </button>
              </div>
            </div>
          </div>
        )} 
        </div>
      //* End Page Content *//
    ) :  null }
  </>
  )    
}